(function (ng) {
    //component definition for the "Initiate a Return" page
    //creates and manages the order lookup to start the return
    //also saves the request state to create the return
    ng.module('evo.returns.initiate.components').component('itemTable', {
        templateUrl: ['TEMPLATES_BASE',
            function (TEMPLATES_BASE) {
                return TEMPLATES_BASE + 'returns/initiate/components/itemTable';
            }],
        controller: function () {
            var ctrl = this;

            ctrl.returnReasonChanged = function (item) {
                ctrl.onReturnReasonChanged({ item, returnReason: item.ReturnReason });
            };
        },
        bindings: {
            items: '<',
            displayMode: '@',
            onReturnReasonChanged: '&'
        }
    });
})(angular);